import styled from "styled-components";

export const _SvgError = styled.span`
  color: ${(props) => props?.theme?.colors?.ERROR};
`;
